import { getItem } from 'helpers/localStorage';
import Sockets from 'helpers/sockets';
import { refreshSession } from 'http/refresh-session';

// TODO: To think, is it possible to make structure with inheritance for socket reducers
// To use this fabric actions object MUST contain redux actions 'socketConnect' and 'socketDisconnect'
export function subscriptionsFabric(actions, eventsEnum, handlers, options = {}) {
  const { connectionOptions, onConnect, onReconnect, onDisconnect, getRoomId, assignedToLocations } = options;
  return (store) => {
    const namespace = eventsEnum.namespace;
    const eventKeys = Object.keys(eventsEnum).filter((key) => key !== 'namespace');
    const eventValues = eventKeys
      .map((key) => eventsEnum[key])
      .filter((event) => !!handlers[event] && typeof handlers[event] === 'function');
    // Save events in map to off exact listeners
    // so for same namespaces and same events there will be possibility to add multiple listeners
    const eventsMap = new Map();
    Sockets.resetReconnectionAttempts(namespace);

    return (next) => async (action) => {
      if (actions.socketConnect?.match(action) && action.payload?.namespace === namespace) {
        const socket = Sockets.getSocket(namespace, {
          connectionOptions,
        });

        if (!socket.connected) {
          let hasConnected = false;
          socket.on('connect', () => {
            Sockets.resetReconnectionAttempts(namespace);

            const rooms = (!!assignedToLocations && typeof assignedToLocations === 'function' && assignedToLocations(store))
              ? store.getState().personalProfile?.user?.assignedToLocations?.map(_id => `location_${_id}`)
              : [getRoomId ? getRoomId(store) : `location_${store.getState().personalProfile?.user?.tenantLocationId}`] 
            rooms.push(store.getState().personalProfile?.user?.tenantId);

            if (rooms?.length && Array.isArray(rooms)) {
              rooms.forEach((room) => socket.emit(`${namespace}:join-room`, room))
            }

            if (onConnect) {
              onConnect(store);
            }

            if (hasConnected) onReconnect?.(store);
            hasConnected = true;
          });

          // Try to reconnect. Off reconnection on disconnecting
          socket.on('disconnect', () => {
            // Try to reconnect only if token exists; otherwise - give up;
            if (getItem('authorization-token')) {
              const reconnection = Sockets.increaseReconnectionAttempt(namespace);
              if (reconnection < 60) { // Consider connection dead after an hour
                const grade = reconnection >= 6 ? 6 : (reconnection || 1);
                setTimeout(() => {
                  if (!socket?.connected && !socket?.active) socket?.connect();
                }, 1000 * (2 ** grade));
              }
            } else {
              Sockets.resetReconnectionAttempts(namespace);
            }

            if (onDisconnect) {
              onDisconnect(store);
            }
          });

          socket.on('connect_failed', (error) => {
            // refresh token only if expired
            if (error.status === 401 && /expired/i.test(error.message)) {
              refreshSession(getItem('authorization-token')).catch(() => {});
            }
          });
        }

        // add listeners only on 'socketConnect' action, so they will be added once
        if (!eventsMap.size) {
          for (const event of eventValues) {
            // for dynamic events
            if (/\{.*\}/.test(event)) {
              const eventListener = await handlers[event](store);

              if (Array.isArray(eventListener)) {
                for (const { name, listener } of eventListener) {
                  socket.on(name, listener);
                  eventsMap.set(name, listener);
                }
              } else {
                socket.on(eventListener.name, eventListener.listener);
                eventsMap.set(eventListener.name, eventListener.listener);
              }

            } else {
              const listener = handlers[event]?.(store);

              socket.on(event, listener);
              eventsMap.set(event, listener);
            }
          }
        }
      }

      // on disconnect (call action on useEffect(() => return () => [HERE]), []);
      if (actions.socketDisconnect?.match(action) && action.payload?.namespace === namespace) {
        const socket = Sockets.getSocket(namespace, { skip: true });
        // check via events map, so in case of multiple calling 'disconnect' event for same area/store ->
        // -> it will off other listeners and connection at all

        if (socket?.connected) {
          if (Sockets.getConsumers(namespace) === 1) {
            for (const [event, listener] of eventsMap) {
              if (!listener || !event) continue;
              socket.off(event, listener);
              eventsMap.delete(event);
            }
          }

          // It will off 'disconnect' and all 'connect' listeners
          Sockets.closeSocket(namespace);
        }
      }

      next(action);
    };
  };
}
